const initialState = {
  portfolios: [],
  snapshots: [],
  snapshot: {}
}

export default function taxHarvestingReducer(state = initialState, action) {
  switch (action.type) {
    case "TAX_HARVESTING_PORTFOLIOS":
      return Object.assign({}, state, {
        portfolios: action.payload
      })
    case "TAX_HARVESTING_CARDS":
      return Object.assign({}, state, {
        snapshots: action.payload
      })
    case "TAX_HARVESTING_CARD":
      return Object.assign({}, state, {
        snapshot: action.payload
      })
    default:
      return state;
  }
}
